import axios from 'axios';

import type { AuthenticationToken, Environment } from '../interfaces';
import { hostsConfig } from '../utils/hosts-config';

export default abstract class AuthenticationDao {
  static async authenticateWithUsernameAndPassword(
    env: Environment,
    username: string,
    password: string,
    internal = false
  ) {
    const url =
      hostsConfig[env][internal ? 'internalSsoServiceUrl' : 'ssoServiceUrl'];

    const { data } = await axios.post<AuthenticationToken>(
      `${url}/sso-tokens`,
      {
        username,
        password,
      }
    );

    return data;
  }

  static async resetPassword(env: Environment, username: string) {
    const url = hostsConfig[env].wolverineServiceUrl;
    const { data } = await axios.post(`${url}/login/pwreset`, { username });
    return data;
  }
  static async recoverUsername(env: Environment, email: string) {
    const url = hostsConfig[env].wolverineServiceUrl;
    const { data } = await axios.post(`${url}/login/username`, { email });
    return data;
  }
}
